import React, { useEffect, useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { useSelector, useDispatch } from 'react-redux';

import { FormControl, MenuItem, Select } from '@mui/material';

import { updatePropertyInfo } from '../../../actions';

import { FORM_CONTROL_FULL_WIDTH_INPUT_STYLE } from '../../../constants/Dashboard/Financing';

import { PROPERTY_TYPE, OCCUPANCY_TYPE } from '../../../constants/Dashboard/Financing/mortgage';

import './HomeFinancingSection.css';

export const HomeFinancingSection = ({ resetValues, checkRates, user }) => {
  const dispatch = useDispatch();
  const { ALL_OCCUPANCY_TYPES, ALL_PROPERTY_TYPES } = useSelector(
    ({ propertyReducer: { ALL_PROPERTY_TYPES, ALL_OCCUPANCY_TYPES } }) => ({
      ALL_PROPERTY_TYPES,
      ALL_OCCUPANCY_TYPES,
    }),
  );
  const [propertyType, setPropertyType] = useState(ALL_PROPERTY_TYPES[0]);
  const [occupancyType, setOccupancyType] = useState(ALL_OCCUPANCY_TYPES[0]);

  useEffect(() => {
    if (resetValues) {
      setPropertyType(ALL_PROPERTY_TYPES[0]);
      setOccupancyType(ALL_OCCUPANCY_TYPES[0]);
    }
  }, [resetValues]);

  useEffect(() => {
    if (checkRates) {
      dispatch((dispatch) => {
        updatePropertyInfo(dispatch, { propertyType, occupancyType });
      });
    }
  }, [checkRates]);

  return (
    <div className="property-occupancy-info-row">
      <div className="financing-field-wrapper property-type">
        <p className="property-type-occupancy-label">{PROPERTY_TYPE}</p>
        <FormControl sx={FORM_CONTROL_FULL_WIDTH_INPUT_STYLE}>
          <Select
            id="financing-select-helper"
            value={propertyType}
            onChange={(e) => {
              setPropertyType(e.target.value);
              dispatch((dispatch) => {
                updatePropertyInfo(dispatch, { propertyType: e.target.value });
              });
              mixpanel.track('Finance Section Home', {
                financingType: 'HOME',
                user_id: user.id,
                FINANCE_FIELD: 'PROPERTY TYPE',
                PROPERTY_TYPE: e.target.value,
              });
            }}
          >
            {ALL_PROPERTY_TYPES.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      <div className="financing-field-wrapper occupancy-type">
        <p className="property-type-occupancy-label">{OCCUPANCY_TYPE}</p>
        <FormControl sx={FORM_CONTROL_FULL_WIDTH_INPUT_STYLE}>
          <Select
            id="financing-select-helper"
            value={occupancyType}
            onChange={(e) => {
              setOccupancyType(e.target.value);
              dispatch((dispatch) => {
                updatePropertyInfo(dispatch, { occupancyType: e.target.value });
              });
              mixpanel.track('Finance Section Home', {
                financingType: 'HOME',
                user_id: user.id,
                FINANCE_FIELD: 'OCCUPANCY TYPE',
                OCCUPANCY_TYPE: e.target.value,
              });
            }}
          >
            {ALL_OCCUPANCY_TYPES.map((category) => (
              <MenuItem key={category} value={category}>
                {category}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};
